
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.006 5.406c-.396 0-.705.213-.705.59 0 1.15.135 2.803.135 3.953 0 .3.261.425.57.425.232 0 .56-.126.56-.425 0-1.15.136-2.803.136-3.953 0-.377-.319-.59-.696-.59zM8.014 11.04a.744.744 0 000 1.488.755.755 0 00.734-.745.749.749 0 00-.734-.744z","fill":"#F77"}}),_c('path',{attrs:{"d":"M15.794 12.7L9.23 1.816A1.445 1.445 0 008 1.121c-.5 0-.972.266-1.231.695L.206 12.7a1.44 1.44 0 001.231 2.18h13.126a1.44 1.44 0 001.23-2.18zm-.886.937a.396.396 0 01-.345.201H1.437a.396.396 0 01-.339-.6L7.661 2.354A.398.398 0 018 2.163c.138 0 .268.073.339.191l6.563 10.884a.396.396 0 01.006.4z","fill":"#F77"}})])
          )
        }
      }
    